<template>
  <div
    class="owal loading poster container"
  >
    <owal-spinner-logo />
    <span
      class="owal loading poster text"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import OwalSpinnerLogo from './OwalSpinnerLogo'
export default {
  name: 'OwalPosterFrameSpinner',
  components: {
    OwalSpinnerLogo,
  },
  props: {
    text: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style scoped>
/** Poster Frame Placeholder */
.owal.loading.poster.container {
  display: flex;
  height: 100%;
  width: 100%;
  background: #fff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.owal.loading.poster.text {
  font-weight: bold;
  font-size: 2rem;
  font-family: 'Lato', 'Avenir', sans-serif;
  color: #000;
}
</style>
